module.exports = __webpack_public_path__ + "img/0xbc5609612b7c44bef426de600b5fd1379db2ecf1.72d1217f.png";